import React from 'react'
import Flex from '../Flex'
import Divider from '../Divider'
import Icon from '../Icon'
import Text from '../Text'
import { StepperProps, Step } from './Stepper.types'

const Stepper: React.FC<StepperProps> = ({ steps }) => {
  return (
    <Flex alignItems='center' columnGap='12px'>
      {steps?.map((step, index) => (
        <React.Fragment key={index}>
          <StepItem {...step} />
          {index !== steps.length - 1 && <Divider width='16px !important' />}
        </React.Fragment>
      ))}
    </Flex>
  )
}

const StepItem: React.FC<Step> = ({ label, text, isActive, isChecked = false }) => (
  <Flex alignItems="center" gap="0.5rem">
    <Flex
      width="1.5rem"
      height="1.5rem"
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
      backgroundColor={isActive ? "blue50" : "black10"}
    >
      {isChecked ? (
        <Icon name="Checkmark-outline" color="white" size="1rem" />
      ) : (
        <Text variant="caption" weight="bold" color="white">
          {label}
        </Text>
      )}
    </Flex>
    <Text color={isActive ? "black75" : "black25"}>{text}</Text>
  </Flex>
);

export default Stepper
